module.exports = __webpack_public_path__ + "img/yjcl.88444552.gif";